import { isString } from './isString'
import { INSTANCE_APP_ROUTE_PATH } from '@/const'

const TENANT_ID_PARAM = 'tenantId='

export function getInstanceIdFromUrl() {
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname

    // Check for instance ID at the beginning of pathname (pattern: /instanceId~...)
    const instanceIdFromStart = pathname.match(/^\/([0-9a-f]{32})~/)?.[1]
    if (isString(instanceIdFromStart)) {
      return instanceIdFromStart
    }

    // Check for instance ID after INSTANCE_APP_ROUTE_PATH (pattern: /i/instanceId/...)
    const instanceId = pathname
      .substring(INSTANCE_APP_ROUTE_PATH?.length ?? 0)
      .match(/^\/([0-9a-f]{32})\b/)?.[1]
    if (isString(instanceId)) {
      return instanceId
    }
    const href = window.location.href
    if (isString(href)) {
      const pos = href.indexOf(TENANT_ID_PARAM)
      if (pos >= 0) {
        const beg = pos + TENANT_ID_PARAM.length
        const end = href.indexOf('&', beg)
        const id = end > pos ? href.substring(beg, end) : href.substring(beg)
        if (isString(id)) {
          return id
        }
      }
    }
  }
  return undefined
}
